module.exports = __webpack_public_path__ + "img/rankdone.02343487.svg";